// ----------------------------------------------------------------------
// <copyright file="Izenda.Draggable.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
/** http://gaearon.github.io/react-dnd/docs-overview.html */

!(function() {
  var m = require('mobx-react');
  var React = require('react');
  var ReactDOM = require('react-dom');
  var DragSource = require('react-dnd').DragSource;
  const { isNil } = require('lodash/fp');
  /**
   * A higher-order component that make a react component becomes draggable
   * @param  {ReactComponent} Component
   * @param  {String} type - Only the drop targets registered for the same type will react to the items produced by this drag source.
   * @param  {Object} options - Set of drag behaviors
   * @return {DraggableComponent}
   * @example
   *    var types = {
   *     CARD: 'CARD',
   *    };
   *
   *    var sourceOptions = {
   *      beginDrag: function (props) { },
   *      endDrag: function (props, monitor, component) { },
   *      ...
   *     };
   *    var InnerCard = require('./Card');
   *    var Card = draggable(types.CARD, sourceOptions)(InnerCard);
   * 		...
   * 		<Card id={1} />
   */
  function draggable(type, options, selfDrag) {
    selfDrag = isNil(selfDrag) || selfDrag;

    return function(Component) {
      /**
       * The collecting function.
       * Specifies which props to inject into your component. It should return a plain object of the props to inject into your component.
       * @param  {DragSourceConnector} connect
       * @param  {DragSourceMonitor} monitor
       * @return {Object}
       */
      function collect(connect, monitor) {
        return {
          connectDragSource: connect.dragSource(),
          connectDragPreview: connect.dragPreview(),
          isDragging: monitor.isDragging()
        };
      }

      var DraggableComponent = React.createClass({
        render: function() {
          var connectDragSource = this.props.connectDragSource;

          var getRef = function(instance) {
            return selfDrag && connectDragSource(ReactDOM.findDOMNode(instance));
          };

          return <Component {...this.props} ref={getRef} />;
        }
      });

      return m.observer(DragSource(type, options, collect)(DraggableComponent));
    };
  }

  module.exports = draggable;
})();



// WEBPACK FOOTER //
// ./ui/share/components/hoc/Izenda.Draggable.jsx